export function getUpdateValue(hpRoles: string[], newHPRoles: string[]) {
  const isAddAction = hpRoles.length < newHPRoles.length
  const updatedValue = isAddAction
    ? newHPRoles.find((value) => !hpRoles.includes(value))
    : hpRoles.find((value) => !newHPRoles.includes(value))

  return { isAddAction, updatedValue }
}
